export default __webpack_public_path__ + "static/media/mandiri.80b06944.png";